import { ActionTree } from 'vuex'

import { PlaceState, RootState } from '@/types/store'

import { getPlaces } from '@/api/place'

export const actions: ActionTree<PlaceState, RootState> = {
  async getPlaces({ commit }, { q }: { q: string }): Promise<void> {
    const places = await getPlaces(q)
    commit('placesLoaded', { places })
  },
}
